import Constant from '@/const';
import axios from 'axios';

const getCity = async provId => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat(
        `/master/region/regency?province=${provId}&search=`,
      ),
    );
    return response;
  } catch (error) {
    const err = error;
    throw err;
  }
};

export default getCity;
